import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import Button from '~/components/Button';

const useStyles = jss.makeStyles((theme) => ({
  root: {
    background: '#fff',
  },
  content: {
    padding: '0 40px 20px 40px',
    minWidth: 450,
  },
  iconContainer: {
    position: 'absolute',
    top: 35,
    left: 35,
    '& *': {
      fontSize: 50,
    },
  },
  typographyContainer: {
    paddingLeft: 60,
  },
  title: {
    fontSize: '2rem',
    fontWeight: 500,
    marginTop: 20,
    marginBottom: 10,
  },
  message: {
    fontSize: '1rem',
  },
  messageSingle: {
    paddingTop: 30,
  },
  dialogTitle: {
    minWidth: 250,
  },
  contentContainer: {
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(0.5),
  },
}));

const OldBaseDialog = ({ title = '', message = '', isVisible = false, onClose = undefined, icon = undefined }) => {
  // @ts-expect-error TS(2339): Property 'propTypes' does not exist on type '({ ti... Remove this comment to see the full error message
  OldBaseDialog.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    icon: PropTypes.element,
  };

  const { t } = useTranslation();
  const styles = useStyles();

  const onClickClose = (e) => {
    e.preventDefault();

    // @ts-expect-error TS(2349): This expression is not callable.
    if (onClose) onClose();
  };

  return (
    <mui.Dialog
      maxWidth={false}
      style={{ width: 'auto' }}
      onBackdropClick={onClickClose}
      onClose={onClickClose}
      open={isVisible}
      PaperProps={{
        style: {
          backgroundColor: '#fff',
        },
      }}
    >
      <mui.DialogContent className={styles.contentContainer}>
        <div className={styles.content} data-testid="dialog-title">
          <div className={styles.iconContainer}>{icon}</div>
          <div className={styles.typographyContainer}>
            {title && (
              <mui.Typography variant="h1" className={styles.title} data-testid="dialog-title">
                {title}
              </mui.Typography>
            )}
            <mui.Typography
              variant="h5"
              className={jss.combineStyles(
                {
                  [styles.messageSingle]: !title,
                },
                styles.message,
              )}
              data-testid="dialog-message"
            >
              {message}
            </mui.Typography>
          </div>
        </div>
      </mui.DialogContent>

      {/*
        // @ts-expect-error TS(2339): Property 'dialogActions' does not exist on type 'C... Remove this comment to see the full error message */}
      <mui.DialogActions className={styles.dialogActions} data-testid="dialog-field">
        <Button color="primary" onClick={onClickClose} data-testid="dialog-ok">
          {/*
            // @ts-expect-error TS(2322): Type 'TFunctionResult' is not assignable to type '... Remove this comment to see the full error message */}
          {t('button.ok')}
        </Button>
      </mui.DialogActions>
    </mui.Dialog>
  );
};

export default OldBaseDialog;
